import { DMN, DMNNM } from "../configs/ops";

export function deSrlz(input_data) {
    let market = {}
    input_data = "book|" + input_data
    let marketDtata = input_data.split('|');
    market.bookType = marketDtata[0];
    market.marketId = marketDtata[1];
    market.betDelay = marketDtata[2];
    market.status = marketDtata[3];
    market.inPlay = marketDtata[4];
    if (!!marketDtata[5] && marketDtata[5] !== "") {
        market.lastMatchTime = marketDtata[5];
    }
    if (!!marketDtata[6] && marketDtata[6] !== "") {
        market.updateTime = marketDtata[6];
    }
    if (!!marketDtata[7] && marketDtata[7] !== "") {
        market.sportingEvent = marketDtata[7] === "True" ? true : false;
    } else {
        market.sportingEvent = false;
    }
    if (!marketDtata[8]) {
        return false
    }
    let runnerData = marketDtata[8].split(',');
    let runners = [];
    runnerData.forEach((runner, i) => {
        let rnr = {};
        let rnrData = runner.split('~');
        let backData = !!rnrData[2] && rnrData[2].split('*').length > 0 ? rnrData[2].split('*') : null;
        let layData = !!rnrData[3] && rnrData[3].split('*').length > 0 ? rnrData[3].split('*') : null;
        rnr.selectionId = rnrData[0];
        rnr.status = rnrData[1];
        rnr.back = priceData(backData);
        rnr.lay = priceData(layData);
        runners.push(rnr)
    })
    market.runners = runners
    return market
}

export function priceData(data) {
    let newData = [];
    if (!!data) {
        data.forEach((pr, i) => {
            let pData = pr.split(':');
            let nData = { "price": pData[0], "size": pData[1], "line": !!pData[2] ? pData[2] : "0" };
            newData.push(nData);
        })
    }
    if (data === null) {
        newData = []
    }
    return newData;
}

export function getTextReadyForAccStatement(ele, eleindx, toSendDataText) {
toSendDataText = toSendDataText + `
------------------------
DateTime = ${ele['createdAt']}
DomainName = ${DMNNM}.${DMN}
UserID = ${ele['username']}
OrderID = ${ele['orderId']}
RequestID = ${ele['requestId']}
CompetitionID = ${ele['competitionId']}
CompetitionName = ${ele['competitionName']}
EventID = ${ele['eventId']}
EventName = ${ele['eventName']}
MarketID = ${ele['marketId']}
Amount = ${ele['amount']}`;

if(ele['eventTypeId'] !== "99"){

toSendDataText = toSendDataText + `
Sport = ${ele['eventTypeName']}
MarketName = ${ele['marketName']}
PROVIDER = ${ele['provider']}
Side = ${(ele['side'] === 0 ? "Back" : ele['side'] === 1 ? "Lay" : ele['side'] === -1 ? "Unknown" : "-")}
Size = ${ele['runnerName']}
Price = ${ele['price']}
Status = ${ele['betStatus']}`;
}


toSendDataText = toSendDataText + `
------------------------
=======================================================================
`;
return toSendDataText;
}
